/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface ParamsProps {
  titulo: string | null;
  idTipoTarefa: string | null;
  idEmpreendimento: string | null;
  observacoes: string | null;
  dataProgramadaRealizacaoTarefa: string | null;
  horaProgramadaRealizacaoTarefa: string | null;
}

interface Params {
  idTarefaLead: string;
  body: ParamsProps;
}

export function useAtualizarTarefaLead(props: Params) {
  const registerData = async () => {
    const ATUALIZAR_TAREFA_LEAD = `${leadsWebEnviroment}/common/tarefas-leads/v1/${props?.idTarefaLead}`;
    return await instance.put(ATUALIZAR_TAREFA_LEAD, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["atualizar_tarefa_lead"],
    onSuccess: () => {
      toast.success("Tarefa atualizada com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      console.log(error?.response);
      if (error?.response?.status >= 500) {
        toast.error(`Houve um erro: Status: ${error?.response?.status}`, {
          autoClose: 10000,
        });
      } else {
        const errorMessages = error.response.data.notifications.map(
          (item: any) => `\n${item?.message}\n`
        );

        toast.error(errorMessages.join(""), { autoClose: 10000 });
      }
    },
  });
  return query;
}
